import {Component, forwardRef} from '@angular/core';
import {FormBuilder, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MerchantService} from '../../../services/merchant.service';
import {InputAutocompleteComponent} from '../input-autocomplete/input-autocomplete.component';
import {Merchant} from '../../../services/model';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
  selector: 'app-merchant-autocomplete',
  templateUrl: '../input-autocomplete/input-autocomplete.component.html',
  styleUrls: ['../input-autocomplete/input-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MerchantAutocompleteComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [CommonModule, MatAutocompleteModule, ReactiveFormsModule, MatFormFieldModule,
    MatIconModule, TranslocoDirective, MatInputModule, MatSelectModule, MatSelectModule, MatIconModule, FormsModule]
})
export class MerchantAutocompleteComponent extends InputAutocompleteComponent<Merchant> {

  constructor(fb: FormBuilder, private merchantService: MerchantService) {
    super(fb);
  }

  override getPlaceholder(): string {
    return 'autocomplete.merchants.placeholder';
  }

  override getData(textPattern: string): Observable<Merchant[]> {
    return this.merchantService.findByNameMatchingText(textPattern);
  }

  override getDisplayFn(): (merchant: Merchant) => string {
    return (merchant: Merchant): string => {
      return merchant?.name || '';
    }
  }
}
